import { useCallback, useContext, useEffect, useState } from "react";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/download.svg";
import PopupEdit from "../../quan-ly-dich-vu-khach-hang/components/popup/PopupEdit";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../contexts/AuthContext";
import { contractService } from "../../../../services/api/contractService";
import { customerProfileService } from "../../../../services/api/customerProfileService";
import { employeeService } from "../../../../services/api/employeeService";
import { processService } from "../../../../services/api/processService";
import { formatDate } from "../../../../utils/DateFormat";
import { getBackendUrl } from "../../../../utils/env";
import {
  absolutifyImgs,
  base64ifyLogos,
  buildPrintHTML,
  PAGE_H,
  PAGE_W,
  toBase64FromPublic,
} from "../../../../utils/PDFUtils";
import Loading from "../../components/Loading";
import Button from "../../components/Button";
import EditHistoryPopup from "../../quan-ly-dich-vu-khach-hang/components/popup/EditHistoryPopup";
import PopupUpdate from "../../quan-ly-dich-vu-khach-hang/components/popup/PopupUpdate";
import { EstimatePopup } from "./popup/EstimatePopup";
import { ReactComponent as MoneyIcon } from "../../../../assets/icons/money.svg";
import ApprovalRequestPopup from "./popup/ApprovalRequestPopup";
import {
  getStatusColor,
  StatusBadge,
} from "../../../../constants/statusConstants";
import { ReactComponent as ApproveIcon } from "../../../../assets/icons/up-align.svg";
import {
  buildDocumentManagerState,
  buildIntellectualPropertyCatalogState,
  getDocumentManagerBackPath,
  getIntellectualPropertyCatalogBackPath,
  isDocumentManagerContext,
  isIntellectualPropertyCatalogContext,
  withDocumentManagerSearch,
  withIntellectualPropertyCatalogSearch,
} from "../../../../utils/navigationContext";

const PLACEHOLDER = "/images/default-profile.png";

const formatData = (response) => {
  const profile = response.profile || {};
  const serviceId = profile.serviceId || {};
  const category = serviceId.category || {};

  return {
    brand: profile?.brand || "",
    formName: serviceId.formName || "",
    customer_name: response.createdByInfo?.account?.fullName || "",
    customer_phone: response.createdByInfo?.phone || "",
    customer_avatar: response.createdByInfo?.avatar?.url || "",
    customer_email: response.createdByInfo?.account?.email || "",
    profile_name: serviceId.serviceName || "",
    profile_image: profile?.logo
      ? profile?.logo
      : profile?.image?.url || PLACEHOLDER,
    soDon: profile?.profileCode || "",
    soBang: profile?.numberOfCertificates || "",
    category: category?.categoryName || "",
    createdDate: profile?.createdDate || "",
    issueDate: profile?.issueDate || "",
    dateActive: profile?.dateActive || "",
    expiryDate: profile?.expiryDate || "",
    status:
      profile?.status === "Chờ duyệt"
        ? { value: "Chờ duyệt", label: "Chờ duyệt" }
        : profile?.status === "Đang triển khai"
          ? { value: "Đang triển khai", label: "Đang triển khai" }
          : profile?.status === "Tạm ngưng"
            ? { value: "Tạm ngưng", label: "Tạm ngưng" }
            : { value: "Đã hoàn thành", label: "Đã hoàn thành" },
    statusColor: getStatusColor(profile?.status),
    assignedStaff: profile?.assignedStaff
      ? {
          value: profile?.assignedStaff?._id,
          label: profile?.assignedStaff?.fullName,
        }
      : null,
    supervisors: (profile?.supervisors || []).map((s) => {
      if (typeof s === "object" && s !== null) {
        return {
          ...s,
          value: s._id || s.id || s.accountId,
          label: s.fullName || s.name || "Không có tên",
        };
      }
      return { value: s, label: s };
    }),
    assignedStaffId: profile?.assignedStaff?._id || null,
    isLookup: profile?.isLookup,
    isRequire: profile?.isRequire,
    isOriginal: profile?.isOriginal || false,
    contentRequire: profile?.contentRequire,
  };
};

const date = new Date();
const day = String(date.getDate()).padStart(2, "0");
const month = String(date.getMonth() + 1).padStart(2, "0");
const year = date.getFullYear();

const convertProfileName = (name) => {
  if (!name) return "";
  let n = String(name).toLowerCase();
  if (n.startsWith("đăng ký")) n = n.substring(8).trim();
  return `Hồ sơ ${n}`;
};

function formatValue(data) {
  return data.includes("Nhóm") ? data : "Nhóm " + data;
}

const DetailForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { token } = useContext(AuthContext);
  const isFromIntellectualPropertyCatalog =
    isIntellectualPropertyCatalogContext(location);
  const isFromDocumentManager = isDocumentManagerContext(location);
  const intellectualPropertyCatalogBackPath =
    getIntellectualPropertyCatalogBackPath(location);
  const intellectualPropertyCatalogState = buildIntellectualPropertyCatalogState(
    location.state || {},
  );
  const documentManagerBackPath = getDocumentManagerBackPath(location);
  const documentManagerState = buildDocumentManagerState(location.state || {});
  const hasNavigationContext =
    isFromIntellectualPropertyCatalog || isFromDocumentManager;
  const contextState = isFromIntellectualPropertyCatalog
    ? intellectualPropertyCatalogState
    : isFromDocumentManager
      ? documentManagerState
      : location.state;
  const contextBackPath = isFromIntellectualPropertyCatalog
    ? intellectualPropertyCatalogBackPath
    : documentManagerBackPath;
  const withContextSearch = (path) => {
    if (isFromIntellectualPropertyCatalog) {
      return withIntellectualPropertyCatalogSearch(path);
    }

    if (isFromDocumentManager) {
      return withDocumentManagerSearch(path);
    }

    return path;
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isUpdatePopupOpen, setIsUpdatePopupOpen] = useState(false);
  const [represent, setRepresent] = useState({});
  const [process, setProcess] = useState([]);
  const [data, setData] = useState({});
  const [documentData, setDocumentData] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [estimateLoading, setEstimateLoading] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [category, setCategory] = useState("");
  const [isEstimateOpen, setIsEstimateOpen] = useState(false);
  const [estimateData, setEstimateData] = useState(null);
  const [staffOptions, setStaffOptions] = useState([]);
  const [isLoadingStaff, setIsLoadingStaff] = useState(false);
  const [isApprovalPopupOpen, setIsApprovalPopupOpen] = useState(false);
  const [isHistoryPopupOpen, setIsHistoryPopupOpen] = useState(false);

  const handleUpdateOpenPopup = () => setIsUpdatePopupOpen(true);
  const handleUpdateClosePopup = () => setIsUpdatePopupOpen(false);
  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => setIsPopupOpen(false);

  const handleOpenEstimate = async () => {
    try {
      setEstimateLoading(true);
      setIsEstimateOpen(true);
      const res = await customerProfileService.get_profile_estimate(token, id);
      setEstimateData(res.data);
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Không thể lấy báo phí hồ sơ",
      );
      setIsEstimateOpen(false);
    } finally {
      setEstimateLoading(false);
    }
  };

  const handleUpdateEstimate = async (estimateId, payload) => {
    try {
      setPageLoading(true);
      const res = await customerProfileService.update_profile_estimate(
        token,
        estimateId,
        payload,
      );
      toast.success("Cập nhật báo phí thành công");
      setEstimateData({ ...res.data, _id: res.data._id });
    } catch (error) {
      toast.error(error.response?.data?.message || "Cập nhật báo phí thất bại");
    } finally {
      setPageLoading(false);
    }
  };

  const handleCloseEstimate = () => {
    setIsEstimateOpen(false);
    setEstimateData(null);
  };

  const refreshEstimate = async () => {
    const res = await customerProfileService.get_profile_estimate(token, id);
    setEstimateData(res.data);
  };

  const fetchData = useCallback(async () => {
    try {
      setPageLoading(true);
      const response = await customerProfileService.get_detail(id, token);
      setCategory(response.data.profile.serviceId.category.categoryName);
      setDocumentData(response.data.profile.info || []);
      setProcess(response.data.profile.processes || []);
      setData(formatData(response.data));
      setRepresent(response.data.profile.represent || "");
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response
          ? `${error.response?.data?.message}`
          : "Không thể kết nối tới server. Vui lòng kiểm tra mạng.",
      );
    } finally {
      setPageLoading(false);
    }
  }, [id, token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handelDuplicateProfile = async () => {
    try {
      setPageLoading(true);
      const res = await customerProfileService.duplicate_profile(id, token);
      const editPath = `/quan-ly-dich-vu-khach-hang/ho-so/${res.profile._id}/chinh-sua`;

      navigate(withContextSearch(editPath), {
        state: contextState,
      });
      toast.success(
        `Đã nhân bản ${convertProfileName(data.profile_name).toLowerCase()} thành công!`,
      );
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response
          ? `${error.response?.data?.message}`
          : "Không thể kết nối tới server.",
      );
    } finally {
      setPageLoading(false);
    }
  };

  const renderContent = (formData) => {
    if (!formData) return null;
    if (!Array.isArray(formData))
      return <div>Không có dữ liệu form đã nhập</div>;

    return (
      <div className="my-6 space-y-6 dynamic-content-wrapper">
        {formData.map((section, index) => {
          const hasFileOrImage =
            Array.isArray(section.fields) &&
            section.fields.some(
              (field) =>
                field.fieldType === "pdf" ||
                field.fieldType === "image" ||
                field.fieldType === "media-group",
            );
          const sectionClass = hasFileOrImage ? "hide-section" : "";
          const sectionKey = section._id || `section-${section.type}-${index}`;

          if (section.type === "Tài liệu gửi kèm (nếu có)") {
            return (
              <div key={sectionKey}>
                {represent && (
                  <div className="space-y-1 my-6">
                    <h4 className="text-md font-sf-semibold uppercase">
                      {index + 1}. Tổ chức đại diện SHCN
                    </h4>
                    <div className="grid grid-cols-1 gap-2">
                      <p className="text-left break-all w-full">
                        {represent.companyName}
                      </p>
                      <p className="text-left break-all w-full">
                        {represent.address}
                      </p>
                    </div>
                  </div>
                )}
                <div className={`mb-4 ${sectionClass} flex-col`}>
                  <h4 className="text-md font-sf-semibold uppercase">
                    {index + 2}. {section.type}
                  </h4>
                  {section.fields.map((field, fieldIndex) => {
                    const fieldKey =
                      field._id || `field-${field.name}-${fieldIndex}`;
                    return (
                      <div className="flex items-center" key={fieldKey}>
                        <strong className="mr-2">{field.name}:</strong>
                        {!field.value ||
                        (Array.isArray(field.value) &&
                          field.value.length === 0) ? (
                          <p>Không có tài liệu đính kèm !</p>
                        ) : typeof field.value === "string" ? (
                          <a
                            className="text-blue-500 hover:text-blue-600 hover:underline"
                            href={field.value}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {field.fieldType === "image"
                              ? "Hình ảnh"
                              : "Tài liệu"}
                          </a>
                        ) : (
                          Array.isArray(field.value) && (
                            <span>
                              {field.value.map((val, idx) => (
                                <span key={`${fieldKey}-${idx}`}>
                                  <a
                                    className="text-blue-500 hover:text-blue-600 hover:underline"
                                    href={val}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Tài liệu
                                  </a>
                                  {idx < field.value.length - 1 ? ", " : ""}
                                </span>
                              ))}
                            </span>
                          )
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          }

          return (
            <div className={`mb-4 ${sectionClass}`} key={sectionKey}>
              <h4 className="text-md font-sf-semibold uppercase">
                {index + 1}. {section.type}
              </h4>
              {section.type === "Danh mục hàng hóa/dịch vụ" ||
              section.type === "Nội dung yêu cầu tra cứu" ||
              section.type === "Kiểu dáng công nghiệp" ||
              section.type === "Sáng chế/giải pháp hữu ích" ||
              section.type === "Tác phẩm" ? (
                <div className="grid grid-cols-1 gap-2">
                  {section.fields.map((field, fieldIndex) => {
                    if (
                      fieldIndex % 2 === 0 &&
                      section.fields[fieldIndex + 1]
                    ) {
                      return (
                        <div
                          key={`pair-${sectionKey}-${fieldIndex}`}
                          className="flex items-start w-full"
                        >
                          <div className="font-semibold whitespace-nowrap mr-2">
                            {formatValue(field.value)}:
                          </div>
                          <div className="text-left break-all w-full">
                            {section.fields[fieldIndex + 1].value}
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              ) : (
                section.fields.map((field, fieldIndex) => {
                  const isPhone =
                    field.name === "Số điện thoại" &&
                    section.fields[fieldIndex + 1]?.name === "Email";
                  const isEmail =
                    field.name === "Email" &&
                    section.fields[fieldIndex - 1]?.name === "Số điện thoại";
                  if (isPhone) {
                    return (
                      <div
                        key={`phone-${sectionKey}-${fieldIndex}`}
                        className="flex items-start space-x-6 hide-section"
                      >
                        <div className="flex items-start">
                          <strong className="mr-2 whitespace-nowrap">
                            {field.name}:
                          </strong>
                          <span className="text-left break-all w-full">
                            {field.value}
                          </span>
                        </div>
                        <div className="flex items-start">
                          <strong className="mr-2 whitespace-nowrap">
                            {section.fields[fieldIndex + 1].name}:
                          </strong>
                          <span className="text-left break-all w-full">
                            {section.fields[fieldIndex + 1].value}
                          </span>
                        </div>
                      </div>
                    );
                  }
                  if (isEmail) return null;
                  return (
                    <div
                      key={field._id || `${sectionKey}-f-${fieldIndex}`}
                      className="flex items-start"
                    >
                      <strong className="mr-2 whitespace-nowrap">
                        {field.name}:
                      </strong>
                      <span className="text-left break-all w-full">
                        {field.value}
                      </span>
                    </div>
                  );
                })
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const handleRequestApprove = async (message) => {
    try {
      setPageLoading(true);
      const res = await contractService.request_profile(token, id, { message });
      toast.success(res?.message || "Đã gửi đề xuất duyệt hồ sơ");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Không thể gửi đề xuất duyệt",
      );
    } finally {
      setPageLoading(false);
    }
  };

  async function handlePrint() {
    try {
      setIsPrinting(true);

      const original = document.getElementById("contentToPrint");
      if (!original) throw new Error("Content to print not found");

      const cloned = original.cloneNode(true);
      absolutifyImgs(cloned);
      await base64ifyLogos(cloned, PLACEHOLDER);

      const watermarkMode = "fixed";
      const htmlContent = buildPrintHTML(cloned.innerHTML, watermarkMode);
      const watermarkBase64 = await toBase64FromPublic(
        "/images/watermark-45.png",
      );
      const BE_URL = getBackendUrl();

      const response = await fetch(`${BE_URL}/pdf/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          html: htmlContent,
          profileName: convertProfileName(data && data.profile_name),
          watermarkBase64,
          watermarkOpacity: 0.12,
          options: { width: PAGE_W, height: PAGE_H, deviceScaleFactor: 2 },
          watermarkMode,
        }),
      });

      if (!response.ok) {
        let msg = "Failed to generate PDF";
        try {
          msg = (await response.json()).message || msg;
        } catch (e) {}
        throw new Error(msg);
      }

      const ct = response.headers.get("content-type") || "";
      if (!ct.includes("application/pdf")) {
        const text = await response.text();
        console.error("Unexpected content-type:", ct, text.slice(0, 200));
        throw new Error("Server did not return a PDF");
      }

      const buf = await response.arrayBuffer();
      const blob = new Blob([buf], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download =
        (convertProfileName(data && data.profile_name) || "document") + ".pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Tải PDF thành công!");
    } catch (err) {
      console.error("PDF generation failed:", err);
      toast.dismiss();
      toast.error((err && err.message) || "Lỗi không tạo được file PDF");
    } finally {
      setIsPrinting(false);
    }
  }

  const handleSaveData = async (updatedData) => {
    try {
      setPageLoading(true);
      const formData = new FormData();
      formData.append("name", updatedData.name);
      formData.append("completionDate", updatedData.completionDate);
      formData.append("pdfFile", updatedData.pdfFile);
      formData.append("status", "Nộp đơn");
      await processService.create(id, formData, token);
      toast.success("Tạo tiến trình mới thành công");
      fetchData();
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response
          ? `${error.response?.data?.message}`
          : "Không thể kết nối tới server.",
      );
    } finally {
      setPageLoading(false);
    }
  };

  const handleUpdateData = async (updatedData) => {
    try {
      setPageLoading(true);
      const payload = {
        profileCode: updatedData.profileCode,
        numberOfCertificates: updatedData.numberOfCertificates,
        createdDate: updatedData.createdDate || null,
        dateActive: updatedData.dateActive || null,
        issueDate: updatedData.issueDate || null,
        expiryDate: updatedData.expiryDate || null,
        status: updatedData.status.value,
        assignedStaff: updatedData.assignedStaff,
        supervisors: updatedData.supervisors,
      };

      await customerProfileService.update_general_profile(id, payload, token);
      toast.success("Chỉnh sửa thông tin hồ sơ thành công");
      fetchData();
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response
          ? `${error.response?.data?.message}`
          : "Không thể kết nối tới server.",
      );
    } finally {
      setPageLoading(false);
    }
  };

  const handleLoadStaffOptions = async () => {
    if (isLoadingStaff || staffOptions.length > 0) return;
    try {
      setIsLoadingStaff(true);
      const response = await employeeService.get_list_staff_short(token);
      setStaffOptions(
        response.data.map((staff) => ({
          value: staff.accountId,
          label: `${staff.fullName} - ${staff.role}`,
          department: staff.department,
        })),
      );
    } catch (error) {
      toast.error("Không thể tải danh sách nhân viên");
    } finally {
      setIsLoadingStaff(false);
    }
  };

  const handleBackToSourceList = () => {
    navigate(contextBackPath, {
      state: contextState,
    });
  };

  const handleNavigateToEditProfile = () => {
    const editPath = `/quan-ly-dich-vu-khach-hang/ho-so/${id}/chinh-sua`;

    navigate(withContextSearch(editPath), {
      state: contextState,
    });
  };

  if (pageLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <div className="h-full overflow-auto">
      <div className="flex flex-col gap-6 w-full bg-white rounded-[16px] border border-[#D2D5DA] p-4">
        {isPrinting && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
            <div className="bg-white px-6 py-4 rounded-lg shadow-lg text-lg font-semibold">
              Đang tạo PDF, vui lòng đợi...
              <div className="mt-3 flex justify-center">
                <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
            </div>
          </div>
        )}
        {hasNavigationContext && (
          <div className="flex justify-start">
            <button
              type="button"
              onClick={handleBackToSourceList}
              className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50"
            >
              <img
                src="/icons/left-arrow-black.svg"
                alt=""
                className="w-4 h-4"
              />
              Quay lại danh sách
            </button>
          </div>
        )}
        <div className="bg-white rounded-lg pt-6 px-6">
          <div className="flex justify-between items-stretch gap-6">
            <div className="flex-1 flex flex-col gap-3">
              <p className="text-gray-500 uppercase font-sf-medium text-sm">
                Thông tin khách hàng
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={data.customer_avatar || "/images/avatar-default.png"}
                  alt="Avatar"
                  className="w-16 h-16 rounded-lg object-cover flex-shrink-0"
                />
                <div className="flex flex-col gap-1 min-w-0">
                  <h3
                    className="text-lg font-sf-semibold truncate"
                    title={data.customer_name}
                  >
                    {data.customer_name}
                  </h3>
                  <div className="text-gray-600 text-sm">
                    {data.customer_phone}
                  </div>
                </div>
              </div>
            </div>

            <div className="w-px bg-gray-300"></div>

            <div className="flex-1 flex flex-col gap-3">
              <p className="text-gray-500 uppercase font-sf-medium text-sm">
                Thông tin chung
              </p>
              <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
                <label className="text-gray-600">Số đơn</label>
                <span className="text-right font-medium">
                  {data?.soDon || "--"}
                </span>
                <label className="text-gray-600">Số văn bằng</label>
                <span className="text-right font-medium">
                  {data?.soBang || "--"}
                </span>
                <label className="text-gray-600">
                  {category === "Nhãn hiệu" ? "Nhãn hiệu" : "Tên hồ sơ"}
                </label>
                <span className="text-right font-medium">{data?.brand}</span>
                <label className="text-gray-600">Trạng thái</label>
                <div className="flex justify-end">
                  <StatusBadge status={data?.status?.value} />
                </div>
                <label className="text-gray-600">Người phụ trách</label>
                <span className="text-right font-medium">
                  {data?.assignedStaff?.label || "--"}
                </span>
                <label className="text-gray-600">Giám sát viên</label>
                <span className="text-right font-medium">
                  {data?.supervisors
                    ?.map((s) => s.label || s.fullName)
                    .join(", ") || "--"}
                </span>
              </div>
            </div>

            <div className="w-px bg-gray-300"></div>

            <div className="flex-1 flex flex-col gap-3">
              <p className="text-gray-500 uppercase font-sf-medium text-sm">
                Dữ liệu
              </p>
              <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
                <label className="text-gray-600">Ngày nộp đơn</label>
                <span className="text-right font-medium">
                  {data?.createdDate ? formatDate(data?.createdDate) : "--"}
                </span>
                <label className="text-gray-600">Ngày cấp bằng</label>
                <span className="text-right font-medium">
                  {data?.issueDate ? formatDate(data?.issueDate) : "--"}
                </span>
                <label className="text-gray-600">Ngày công bố</label>
                <span className="text-right font-medium">
                  {data?.dateActive ? formatDate(data?.dateActive) : "--"}
                </span>
                <label className="text-gray-600">Ngày hết hạn</label>
                <span className="text-right font-medium">
                  {data?.expiryDate ? formatDate(data?.expiryDate) : "--"}
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end gap-3 mt-6 mb-4 pb-2">
            <button
              onClick={() => setIsHistoryPopupOpen(true)}
              className="flex items-center gap-2 px-4 py-2.5 border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 rounded-lg font-medium transition-colors"
            >
              <img src="/icons/history.svg" alt="History" className="w-5 h-5" />
              Xem lịch sử thay đổi
            </button>
            {data?.status?.value === "Chờ duyệt" && (
              <button
                onClick={() => setIsApprovalPopupOpen(true)}
                className="flex items-center gap-2 px-4 py-2.5 border border-blue-600 text-blue-600 bg-white hover:bg-blue-50 rounded-lg font-medium transition-colors"
              >
                <ApproveIcon className="w-5 h-5" />
                Đề xuất duyệt
              </button>
            )}
            <button
              onClick={handleUpdateOpenPopup}
              className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors shadow-sm"
            >
              <img src="/icons/edit.svg" alt="Edit" className="w-5 h-5" />
              Chỉnh sửa thông tin
            </button>
          </div>
        </div>

        <div className="relative" id="contentToPrint">
          <div className="bg-white rounded-[16px] p-4 flex flex-col gap-4 profile-container">
            <h1 className="w-full text-center font-sf-semibold profile-heading text-[#0457C2] text-[1.5rem] uppercase border-b p-4">
              {convertProfileName(data.profile_name)}
            </h1>

            <div className="mt-10">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-6 gap-x-4 mb-8 profile-meta-grid">
                {[
                  ["Số đơn:", data?.soDon || "--"],
                  [
                    "Ngày nộp đơn:",
                    data?.createdDate ? formatDate(data?.createdDate) : "--",
                  ],
                  [
                    "Ngày công bố:",
                    data?.dateActive ? formatDate(data?.dateActive) : "--",
                  ],
                  ["Số bằng:", data?.soBang || "--"],
                  [
                    "Ngày cấp bằng:",
                    data?.issueDate ? formatDate(data?.issueDate) : "--",
                  ],
                  [
                    "Ngày hết hạn:",
                    data?.expiryDate ? formatDate(data?.expiryDate) : "--",
                  ],
                  [
                    category === "Nhãn hiệu" ? "Nhãn hiệu:" : "Tên hồ sơ:",
                    data?.brand || "",
                  ],
                ].map(([label, value], i) => (
                  <div key={i} className="flex items-center meta-item">
                    <strong className="mr-2 whitespace-nowrap">{label}</strong>
                    <span className="whitespace-nowrap meta-value">
                      {value}
                    </span>
                  </div>
                ))}
              </div>

              <div className="w-full flex items-center justify-center mt-8 mb-6 gap-4">
                {Array.isArray(data.profile_image) ? (
                  data.profile_image.length > 0 ? (
                    data.profile_image.map((imgUrl, index) => (
                      <img
                        key={imgUrl._id || imgUrl.value || `logo-${index}`}
                        src={imgUrl.value || PLACEHOLDER}
                        alt="So huu tri tue logo"
                        className="profile-logo h-[7.5rem] object-contain"
                        onError={(e) => (e.currentTarget.src = PLACEHOLDER)}
                      />
                    ))
                  ) : (
                    <img
                      src={PLACEHOLDER}
                      alt="So huu tri tue logo"
                      className="profile-logo h-[7.5rem] object-contain"
                    />
                  )
                ) : (
                  <img
                    src={data.profile_image || PLACEHOLDER}
                    alt="So huu tri tue logo"
                    className="profile-logo h-[7.5rem] object-contain"
                    onError={(e) => (e.currentTarget.src = PLACEHOLDER)}
                  />
                )}
              </div>

              {renderContent(documentData)}

              {(data?.isLookup || data?.isRequire || data?.isOriginal) && (
                <div className="mt-8 space-y-3 bg-blue-50/50 p-6 rounded-xl border border-blue-100">
                  <h4 className="font-sf-semibold text-[#0457C2] uppercase text-sm tracking-wide">
                    Thông tin bổ sung
                  </h4>
                  <div className="flex flex-col gap-3">
                    {data?.isOriginal && (
                      <div className="flex items-center gap-3">
                        <div className="size-2.5 rounded-full bg-blue-500 shadow-sm shadow-blue-200"></div>
                        <span className="font-sf-medium text-gray-700">
                          Hồ sơ gốc tài sản trí tuệ
                        </span>
                      </div>
                    )}
                    {data?.isLookup && (
                      <div className="flex items-center gap-3">
                        <div className="size-2.5 rounded-full bg-blue-500 shadow-sm shadow-blue-200"></div>
                        <span className="font-sf-medium text-gray-700">
                          Có yêu cầu Tra cứu
                        </span>
                      </div>
                    )}
                    {data?.isRequire && (
                      <div className="space-y-3">
                        <div className="flex items-center gap-3">
                          <div className="size-2.5 rounded-full bg-blue-500 shadow-sm shadow-blue-200"></div>
                          <span className="font-sf-medium text-gray-700">
                            Có yêu cầu khác
                          </span>
                        </div>
                        {data?.contentRequire && (
                          <div className="ml-5.5 p-4 bg-white/80 rounded-lg border border-blue-50 text-sm text-gray-700 italic leading-relaxed shadow-sm">
                            {data.contentRequire.replace(/^"|"$/g, "")}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="bg-white border rounded-lg overflow-hidden mt-8">
                <h4 className="text-white table-heading font-sf-medium bg-[#0457C2] px-3 py-3 rounded-t-lg">
                  Tiến trình hồ sơ
                </h4>
                <table className="w-full text-left">
                  <thead>
                    <tr className="bg-gray-200 font-sf-medium h-[60px]">
                      <th className="px-3 py-3">STT</th>
                      <th className="px-3 py-3">Nội dung xử lý</th>
                      <th className="px-3 py-3">Ngày hoàn thành</th>
                      <th className="px-3 py-3">Tài liệu</th>
                    </tr>
                  </thead>
                  <tbody>
                    {process.length > 0 ? (
                      process.map((item, index) => (
                        <tr
                          key={item._id || `process-${index}`}
                          className="hover:bg-blue-50 border-b"
                        >
                          <td className="p-3">{index + 1}</td>
                          <td className="p-3">{item.processContent}</td>
                          <td className="p-3">
                            {formatDate(item.completionDate)}
                          </td>
                          <td className="p-3 text-blue-600">
                            {item.pdfUrl ? (
                              <a
                                href={item.pdfUrl}
                                className="hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Tài liệu
                              </a>
                            ) : (
                              "--"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={4}
                          className="p-4 text-center text-gray-400 italic"
                        >
                          Chưa có tiến trình nào được ghi nhận
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div
                id="download-btn"
                className="w-full flex items-center justify-center gap-3 mt-8 mb-10 hide-section"
              >
                <Button
                  variant="unstyled"
                  onClick={handleOpenEstimate}
                  leftIcon={<MoneyIcon className="size-5 shrink-0" />}
                  className="min-h-[42px] rounded-lg border border-orange-500 px-4 py-2 text-sm font-sf-medium text-orange-600 transition-colors hover:bg-orange-500 hover:text-white"
                >
                  Báo phí
                </Button>
                <Button
                  variant="primary"
                  onClick={handleNavigateToEditProfile}
                  leftIcon={
                    <img
                      src="/icons/edit.svg"
                      alt=""
                      className="size-5 object-contain"
                    />
                  }
                  className="border-gray-300 bg-gray-300 hover:border-gray-500 hover:bg-gray-500"
                >
                  Chỉnh sửa hồ sơ
                </Button>
                <Button
                  variant="darkBlue"
                  onClick={handleOpenPopup}
                  leftIcon={
                    <img
                      src="/icons/edit.svg"
                      alt=""
                      className="size-5 object-contain"
                    />
                  }
                  className="border-[#0457C2] bg-[#0457C2] hover:bg-blue-600"
                >
                  Cập nhật tiến trình
                </Button>
                <Button
                  variant="outline"
                  onClick={handlePrint}
                  leftIcon={<DownloadIcon className="size-5 shrink-0" />}
                  className="border-[#0457C2] text-black hover:bg-blue-600 hover:text-white"
                >
                  Tải hồ sơ
                </Button>
                <Button
                  variant="darkBlue"
                  onClick={handelDuplicateProfile}
                  leftIcon={
                    <img
                      src="/icons/copy.svg"
                      alt=""
                      className="size-5 object-contain"
                    />
                  }
                  className="border-[#0457C2] bg-[#0457C2] hover:bg-blue-600"
                >
                  Nhân bản hồ sơ
                </Button>
              </div>

              <p className="profile-download-footer w-full text-center text-[#333333] mt-16">
                Hồ sơ được tải về ngày {`${day}/${month}/${year}`} từ Nền tảng
                số Sohuutritue.vn
                <br />
                Tổng đài tư vấn Sở hữu trí tuệ:{" "}
                <a href="tel:0819009697" className="hover:underline">
                  08 1900 9697
                </a>{" "}
                (điện thoại, zalo) - Email:{" "}
                <a
                  href="mailto:luatsu@sohuutritue.vn"
                  className="text-blue-600 hover:underline"
                >
                  luatsu@sohuutritue.vn
                </a>
              </p>
            </div>
          </div>
        </div>

        {isHistoryPopupOpen && (
          <EditHistoryPopup
            isOpen={isHistoryPopupOpen}
            onClose={() => setIsHistoryPopupOpen(false)}
            profileId={id}
            token={token}
          />
        )}
        {isUpdatePopupOpen && (
          <PopupUpdate
            isOpen={isUpdatePopupOpen}
            onClose={handleUpdateClosePopup}
            data={data}
            onSave={handleUpdateData}
            staffOptions={staffOptions}
            onLoadStaff={handleLoadStaffOptions}
          />
        )}
        {isPopupOpen && (
          <PopupEdit
            isOpen={isPopupOpen}
            onClose={handleClosePopup}
            data={process}
            onSave={handleSaveData}
            profileId={id}
            token={token}
          />
        )}
        {isEstimateOpen && (
          <EstimatePopup
            isOpen={isEstimateOpen}
            onClose={handleCloseEstimate}
            data={estimateData}
            onUpdate={handleUpdateEstimate}
            getAdjustmentHistory={
              customerProfileService.get_estimate_adjustment_history
            }
            getPendingAdjustment={customerProfileService.get_pending_adjustment}
            updatePendingAdjustment={
              customerProfileService.update_pending_adjustment
            }
            deletePendingAdjustment={
              customerProfileService.delete_pending_adjustment
            }
            deleteAdjustmentHistory={
              customerProfileService.delete_adjustment_history
            }
            onAdjustmentDeleted={refreshEstimate}
            loading={estimateLoading}
          />
        )}
        <ApprovalRequestPopup
          isOpen={isApprovalPopupOpen}
          onClose={() => setIsApprovalPopupOpen(false)}
          onSubmit={handleRequestApprove}
        />
      </div>
    </div>
  );
};

export default DetailForm;
